module.exports = __webpack_public_path__ + "static/media/img2-1.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/ZN/img2-1.png
// module id = 2176
// module chunks = 3